<template>
    <b-container fluid class="mt--7">
        <b-row>
            <b-col>
                <reports-table title="Reports" ref="table"></reports-table>
            </b-col>
        </b-row>
    </b-container>
</template>
<script>
import ReportsTable from './ReportsTable'
import permissionsMixins from '@/mixins/permissionsMixins'


export default {
    name: 'reports',
    mixins: [permissionsMixins],
    components: {
        ReportsTable,
    },

    methods: {},
}
</script>
<style></style>
